// extracted by mini-css-extract-plugin
export default {"articlePage":"HelpArticlePage_articlePage__wPQq6","articleContent":"HelpArticlePage_articleContent__HZTl2"};